export { default } from "@/features/events/screens/event-participants";
